import { render, staticRenderFns } from "./OptionsPost.vue?vue&type=template&id=702ea46c"
import script from "./OptionsPost.vue?vue&type=script&lang=ts"
export * from "./OptionsPost.vue?vue&type=script&lang=ts"
import style0 from "./OptionsPost.vue?vue&type=style&index=0&id=702ea46c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports